import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFilter1"><Path d="M17.25 3.75H6.75C5.09315 3.75 3.75 5.09835 3.75 6.7552C3.75 7.55085 4.06607 8.31607 4.62868 8.87868L8.87132 13.1213C9.43393 13.6839 9.75 14.447 9.75 15.2426V21.25L14.25 20V15.2426C14.25 14.447 14.5661 13.6839 15.1287 13.1213L19.3713 8.87868C19.9339 8.31607 20.25 7.55085 20.25 6.7552C20.25 5.09835 18.9069 3.75 17.25 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFilter1;
